export default {
  "name": "NCAttachment",
  "column": 1,
  "canAppend": false,
  "type": 1,
  "path": "LowCodeComponents.NCAttachment",
  "label": "附件",
  "schema": {
    "type": "object",
    "properties": {
      "moduleId": {
        "title": "区域编码",
        "description": "组件标识",
        "type": "string"
      },
      "disableModify": {
        "title": "禁止修改",
        "description": "禁止修改",
        "type": "boolean"
      },
      "fieldValue": {
        "title": "附件信息",
        "description": "附件信息",
        "type": "string"
      }
    },
    "required": [
      "moduleId"
    ]
  },
  "uiSchema": {},
  "slots": []
}